import { createApi } from "@reduxjs/toolkit/query/react";
import { baseApiQuery } from "../../../shared/api";
import { BaseResponse } from "../../../shared/types";
import {
  CreateHobbyRequest,
  HobbiesResponse,
  HobbyResponse,
  UpdateHobbyRequest,
} from "./types";

export const hobbiesApi = createApi({
  reducerPath: "hobbiesApi",
  baseQuery: baseApiQuery,
  tagTypes: ["Hobbies"],
  endpoints: (builder) => ({
    getHobbies: builder.query<HobbiesResponse, void>({
      query: () => "/admin/hobbies",
      providesTags: ["Hobbies"],
    }),

    createHobby: builder.mutation<HobbyResponse, CreateHobbyRequest>({
      query: (body) => ({
        url: "/admin/hobbies",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Hobbies"],
    }),

    updateHobby: builder.mutation<
      HobbyResponse,
      { id: number; body: UpdateHobbyRequest }
    >({
      query: ({ id, body }) => ({
        url: `/admin/hobbies/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Hobbies"],
    }),

    deleteHobby: builder.mutation<BaseResponse, number>({
      query: (id) => ({
        url: `/admin/hobbies/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Hobbies"],
    }),
  }),
});

export const {
  useGetHobbiesQuery,
  useCreateHobbyMutation,
  useUpdateHobbyMutation,
  useDeleteHobbyMutation,
} = hobbiesApi;
